var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getAppExchangeBaseUrl } from '@/shared/utils/helpers';
import { CompanyStatus } from '@/overmind/search/state';
import { mixpanelTracking } from '@/services/mixpanel';
import WhatsApp from './Applets/WhatsApp.vue';
import Calendar from './Applets/Calendar.vue';
import Notes from './Applets/Notes.vue';
import Record from './Applets/Record.vue';
let CompanyDrawerApplets = class CompanyDrawerApplets extends Vue {
    constructor() {
        super(...arguments);
        this.baseUrl = '';
        this.showApplets = true;
        this.showAnotationApp = false;
        this.showRecordApp = false;
        this.showDecisores = false;
        this.showExternalApp = false;
        this.showCalendarApp = false;
        this.showWhatsapp = false;
        this.loadingApp = false;
        this.urlBaseDecisores = `${getAppExchangeBaseUrl()}/app-decisores`;
        this.urlBaseWhatsapp = `${getAppExchangeBaseUrl()}/app-whatsapp`;
        this.token = '';
        this.urlDecisors = '';
        this.loadingComponent = false;
        this.appnnAnotation = { icon: 'icon-annotations', label: 'Anotações' };
        this.companyApplets = [
            { icon: 'icon-calendar', label: 'Calendário' },
            { icon: 'icon-recordings', label: 'Registro' },
            // { icon: 'icon-add-user', label: 'Mais Decisores' },
            { icon: 'icon-whatsapp', label: 'Whatsapp' },
        ];
        this.showDrawerApplets = false;
    }
    get company() {
        if (this.currentCompany == null || this.currentCompany == undefined)
            return {};
        return this.currentCompany;
    }
    get viewAs() {
        const viewAs = this.$route.query.view_as;
        return viewAs ? `&viewAs=${this.$route.query.view_as}` : '';
    }
    additionalContactDataPhonesIsPresent() {
        return !!(this.company &&
            this.company.additionalContactData &&
            this.company.additionalContactData.phones &&
            this.company.additionalContactData.phones.length > 0);
    }
    companyHasWhatsappValidPhones(label) {
        if (label !== 'Whatsapp')
            return true;
        return this.whatsappPhone.length > 0;
    }
    get hasSomeAppletActive() {
        return (this.showAnotationApp ||
            this.showRecordApp ||
            this.showCalendarApp ||
            this.showWhatsapp);
    }
    get whatsappPhone() {
        if (!this.additionalContactDataPhonesIsPresent())
            return [];
        const whatsappValidations = this.company.whatsapp_validation || [];
        const phones = 
        //@ts-ignore
        this.company.additionalContactData.phones
            .filter((phoneData) => {
            const phone = phoneData.phone_formatted || phoneData.phone;
            if (!phone)
                return false;
            const cleanedPhone = phone.toString().replace(/\D/g, '');
            return whatsappValidations.some(wv => wv.message === 'Active' &&
                (wv.phone === cleanedPhone ||
                    wv.phone.endsWith(cleanedPhone) ||
                    cleanedPhone.endsWith(wv.phone)));
        })
            .map((e) => e.phone_formatted || e.phone);
        return phones || [];
    }
    async created() {
        this.token = localStorage.getItem('auth_token_default');
        this.baseUrl = getAppExchangeBaseUrl();
    }
    async confirmRemove() {
        this.loadingApp = true;
    }
    onCompanyStatus(currVal) {
        if (currVal === CompanyStatus.FETCH_SUCCESS ||
            currVal === CompanyStatus.INITIAL)
            this.showDrawerApplets = true;
        else
            this.showDrawerApplets = false;
    }
    get companyName() {
        return this.company.fantasyName
            ? this.company.fantasyName
            : this.company.name;
    }
    // tracking
    handleMixpanelTracking(text) {
        return mixpanelTracking(text);
    }
    // end
    async showAnotation() {
        this.loadedApp();
        this.showAnotationApp = true;
        this.showExternalApp = true;
        this.showWhatsapp = false;
        this.showCalendarApp = false;
        this.showRecordApp = false;
        this.showDecisores = false;
    }
    removeNote(note) {
        // This method is no longer used by the native component
    }
    showApp(item) {
        this.handleMixpanelTracking(`pre-crm: Abriu o app ${item.label}`);
        setTimeout(() => {
            this.loadingApp = true;
        }, 10);
        if (item.label === 'Anotações') {
            this.showAnotationApp = true;
            this.showExternalApp = true;
            this.showWhatsapp = false;
            this.showCalendarApp = false;
            this.showRecordApp = false;
            this.showDecisores = false;
            this.loadedApp();
        }
        else if (item.label === 'Registro') {
            this.showAnotationApp = false;
            this.showCalendarApp = false;
            this.showDecisores = false;
            this.showRecordApp = true;
            this.showExternalApp = true;
            this.showWhatsapp = false;
            this.loadedApp();
        }
        else if (item.label === 'Mais Decisores') {
            this.showDecisores = true;
            this.showExternalApp = true;
            this.showAnotationApp = false;
            this.showRecordApp = false;
            this.showCalendarApp = false;
            this.showWhatsapp = false;
            this.urlDecisors = `${this.baseUrl}/app-decisores?token=${this.token}&companyId=${this.companyId}&infosetId=${this.infosetId}`;
            this.loadedApp();
        }
        else if (item.label === 'Calendário') {
            this.showAnotationApp = false;
            this.showRecordApp = false;
            this.showCalendarApp = true;
            this.showExternalApp = true;
            this.showWhatsapp = false;
            this.loadedApp();
        }
        else if (item.label === 'Whatsapp') {
            this.showAnotationApp = false;
            this.showRecordApp = false;
            this.showCalendarApp = false;
            this.showWhatsapp = true;
            this.showExternalApp = true;
            this.loadedApp();
        }
        else {
            return false;
        }
    }
    loadedApp() {
        setTimeout(() => {
            this.loadingApp = false;
        }, 1000);
    }
    closeApp() {
        this.showAnotationApp = false;
        this.showExternalApp = false;
        this.showRecordApp = false;
        this.showCalendarApp = false;
        this.showWhatsapp = false;
        this.showDecisores = false;
    }
    dateExpiresDisabledBeforeToday(date) {
        const today = new Date();
        return date < today;
    }
    setcategoriesName({ value }, type) {
        return { value, type };
    }
};
__decorate([
    Prop({ default: '' })
], CompanyDrawerApplets.prototype, "infosetId", void 0);
__decorate([
    Prop({ default: '' })
], CompanyDrawerApplets.prototype, "companyId", void 0);
__decorate([
    Prop({ default: () => { } })
], CompanyDrawerApplets.prototype, "currentCompany", void 0);
__decorate([
    Prop({ default: false })
], CompanyDrawerApplets.prototype, "disableApps", void 0);
__decorate([
    Prop({ default: CompanyStatus.INITIAL })
], CompanyDrawerApplets.prototype, "companyStatus", void 0);
__decorate([
    Watch('companyStatus', { immediate: true })
], CompanyDrawerApplets.prototype, "onCompanyStatus", null);
CompanyDrawerApplets = __decorate([
    Component({
        name: 'CompanyDrawerApplets',
        components: {
            WhatsApp,
            Calendar,
            Notes,
            Record,
        },
    })
], CompanyDrawerApplets);
export default CompanyDrawerApplets;
